import HOCAddPatient from '@components/hoc-add-patient';
import useDebounce from '@hooks/utils/useDebounce';
import { FilterOutlined, PlusOutlined, SearchOutlined } from '@icon';
import { Badge, Dropdown, IconButton, TextField } from '@ui';
import React from 'react';
import { TClientPairingStatus } from 'types/client.types';

const Btn = ({ onAddPatient }: any) => (
  <IconButton size="medium" variant="primary" onClick={onAddPatient} Icon={PlusOutlined} />
);

const WrappedBtn = HOCAddPatient(Btn);

export type TSearchValues = {
  query: string;
  status: TClientPairingStatus | 'all';
};

interface TableHeaderProps {
  refetch: () => void;
  onParamsChange: (p: TSearchValues) => void;
  canEdit?: boolean;
}

const TableFilter: React.FunctionComponent<TableHeaderProps> = ({
  refetch,
  onParamsChange,
  canEdit,
}) => {
  const [searchValues, setSearchValues] = React.useState<TSearchValues>({
    query: '',
    status: 'all',
  });
  const debounced = useDebounce(searchValues, 500);

  React.useEffect(() => {
    onParamsChange(debounced);
  }, [debounced]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 16, position: 'relative' }}>
      <TextField
        right={<TextField.Icon Icon={SearchOutlined} />}
        value={searchValues.query}
        onChange={(e) => {
          setSearchValues((o) => ({ ...o, query: e.target.value }));
        }}
        clearable
        style={{ minWidth: 267 }}
      />
      <Dropdown
        menu={{
          items: [
            { key: 'all', label: 'Všetci' },
            { type: 'divider' },
            { key: 'invited', label: 'Pozvaný' },
            { key: 'pending', label: 'Čakajúci' },
            { key: 'rejected', label: 'Odmietnutý' },
            { key: 'paired', label: 'Prijatý' },
          ],
          selectMode: 'single',
          selectedKeys: [searchValues.status],
          onSelect: (e) => {
            setSearchValues((o) => ({ ...o, status: e.key as any }));
          },
        }}
        trigger={['click']}
        placement="bottomRight"
      >
        <div style={{ position: 'relative' }}>
          <Badge
            content={searchValues.status !== 'all' ? 1 : 0}
            positionHorizontal="right"
            positionVertical="top"
          >
            <IconButton size="medium" variant="secondary" Icon={FilterOutlined}></IconButton>
          </Badge>
        </div>
      </Dropdown>
      {canEdit ? <WrappedBtn afterSubmit={() => refetch()} /> : null}
    </div>
  );
};

export default TableFilter;
